import { CommonConstants } from '@/config/constant';
import { MESSAGE_MAP } from '@/config/message';
import * as parentRouter from '@/router';
import { store } from '@/store';

export const useHistoryBack = () => {
  const historyEntryBack = async () => {
    let useRegistSms = store.getters['event/parentEventInfo'].useLoginSms;
    const useEntrySms = !((useRegistSms === CommonConstants.typePhone && store.getters['event/parentEventInfo']?.isLoginPhone) ||
      (useRegistSms === CommonConstants.typeSms && store.getters['event/parentEventInfo']?.isLoginOnlyPhone));

    await store.dispatch('event/getParentEventInfo');
    if (parentRouter.default.currentRoute.value.name === 'Entry' && (useRegistSms || useRegistSms == 0) && (useRegistSms !== store.getters['event/parentEventInfo']?.useLoginSms) && useEntrySms) {
      store.dispatch('common/setErrors', [MESSAGE_MAP.isChangeUseLoginSms]);
      store.dispatch('common/openErrorModal', true);
      store.dispatch('common/setBackRouteName', 'EntrySms');
      return true;
    }
    return false;
  };
  const historyBack = async () => {
    if (['Entry', 'EntrySms'].includes(parentRouter.default.currentRoute.value.name)) {
      if (await historyEntryBack()) return;
      const isOnlyEntrySms = parentRouter.default.currentRoute.value.name === 'EntrySms' && (store.getters['event/parentEventInfo']?.isLoginPhone || store.getters['event/parentEventInfo']?.isLoginOnlyPhone);
      const isEntrySms = JSON.parse(localStorage.getItem('isLoginSms')) && !store.getters['event/parentEventInfo']?.isLoginNormal;
      parentRouter.default.push({ name: (isOnlyEntrySms || isEntrySms) ? 'LoginSms' : 'Login' });
    } else if (parentRouter.default.currentRoute.value.name === 'SearchShop') {
      parentRouter.default.push({ name: 'Search' });
    } else if (parentRouter.default.currentRoute.value.name === 'Pay' && store.getters['common/isPayCameraOpened']) {
      if (parentRouter.default.currentRoute.value.query?.backToHome) {
        parentRouter.default.replace({ name: 'Home' });
        return;
      }
      if (store.getters['common/isPayCameraOpened']) {
        if (store.getters['event/usePosFlag']) {
          store.dispatch('common/setPayCameraOpen', false);
          parentRouter.default.go(-1);
          return;
        } else {
          store.dispatch('common/setPayCameraOpen', false);
          window.location.reload();
          return;
        }
      } else {
        parentRouter.default.go(-1);
        return;
      }
    } else if (parentRouter.default.currentRoute.value.name === 'CreditRegister' && parentRouter.default.currentRoute.value.query?.backToCharge) {
      parentRouter.default.replace({ name: 'Charge', query: { backToHome: true }});
    } else if (parentRouter.default.currentRoute.value.name === 'Charge') {
      if (parentRouter.default.currentRoute.value.query?.backToHome) {
        parentRouter.default.replace({ name: 'Home' });
      } else {
        parentRouter.default.go(-1);
      }
    } else if (['CurrencyKeyword', 'CurrencyConfirm', 'Security', 'ChildPointOtp', 'ChildPointConfirm', 'ChildPointKeyword'].includes(parentRouter.default.currentRoute.value.name)) {
      parentRouter.default.push({ name: 'Mypage', ...(parentRouter.default.currentRoute.value.name === 'Security' && { params: { directory: parentRouter.default.currentRoute.value.query?.directory } }) });
    } else if (parentRouter.default.currentRoute.value.name === 'Credit') {
      parentRouter.default.push({ name: 'Charge' });
    } else if (parentRouter.default.currentRoute.value.name === 'AccountIdentityFinish') {
      parentRouter.default.push({ name: 'EntryInputConfirm' });
    } else if (['IdentityConfirm', 'IdentitySMS', 'Monitoring'].includes(parentRouter.default.currentRoute.value.name)) {
      if (parentRouter.default.currentRoute.value.query?.chargePage) {
        parentRouter.default.push({ name: 'Charge' });
      } else if (parentRouter.default.currentRoute.value.query?.creditPage) {
        parentRouter.default.push({ name: 'Credit' });
      } else if (parentRouter.default.currentRoute.value.query?.securityPage) {
        parentRouter.default.push({ name: 'Security', query: { directory: parentRouter.default.currentRoute.value.params.directory } });
      } else {
        parentRouter.default.push({ name: 'Mypage' });
      }
    } else if (parentRouter.default.currentRoute.value.name === 'MonitoringEntry' || parentRouter.default.currentRoute.value.name?.includes('MonitoringHistory')) {
      parentRouter.default.push({ name: 'Monitoring' });
    } else if (parentRouter.default.currentRoute.value.name === 'Coupon' && store.getters['shop/isErrorCouponDetail']) {
      parentRouter.default.push({ name: 'Shop', params: { id: parentRouter.default.currentRoute.value.params.id } });
    } else if (['SearchCoupon', 'TicketFinish', 'CurrencyFinish', 'ChildPointFinish'].includes(parentRouter.default.currentRoute.value.name) ||
    (parentRouter.default.currentRoute.value.name === 'Mypage' && parentRouter.default.currentRoute.value.query?.backHome)) {
      parentRouter.default.push({ name: 'Home' });
    } else if (['CouponFinish', 'ParentPayFinish', 'ParentIdentityConfirm', 'ParentPointFinish', 'ParentIdentityFinish', 'ParentPointConfirm', 'ParentPointOtp', 'ParentPointKeyword'].includes(parentRouter.default.currentRoute.value.name) || JSON.parse(sessionStorage.getItem('isFinishedCoupon'))) {
      sessionStorage.removeItem('isFinishedCoupon');
      parentRouter.default.push({ name: 'EventList' });
    } else if (parentRouter.default.currentRoute.value.name === 'GalleryDetail') {
      if (parentRouter.default.currentRoute.value.query?.members) {
        parentRouter.default.push({ name: 'Gallery', params: { ...parentRouter.default.currentRoute.value.params }});
      } else {
        parentRouter.default.go(-1);
      }
    } else if (window.history.length > 1) {
      const backTwoPagesList = ['CouponFinish', 'TicketFinish', 'CurrencyFinish', 'ChildPointFinish'];
      if (backTwoPagesList.includes(parentRouter.default.currentRoute.value.name) || !!JSON.parse(sessionStorage.getItem('isDoubleBack'))) {
        parentRouter.default.go(-2);
        sessionStorage.removeItem('isDoubleBack');
      } else {
        parentRouter.default.go(-1);
      }
    } else {
      parentRouter.default.push({ name: 'Home' });
    }
  };

  return {
    historyBack,
    historyEntryBack,
  };
};
